/* global graphql  */
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'
import HeroVideo from '../components/hero-video'
import ScrollingBanner from '../components/scrolling-banner'
import VerticalList from '../components/vertical-list'
import ImageSlider from '../components/image-slider'
import attnAssemblyLogo from '../assets/img/svg/attn-assembly-logo.svg'

const images = [
  {
    name: 'Assembly image 1',
    src: '/img/creativeshop/assembly-image-1.png'
  },
  {
    name: 'Assembly image 2',
    src: '/img/creativeshop/assembly-image-2.png'
  },
  {
    name: 'Assembly image 3',
    src: '/img/creativeshop/assembly-image-3.png'
  }
]

const CreativeShopPage = ({ data }) => (
  <div className='wrapper--page-dark page--creative-shop'>
    <Helmet title='Creative Shop - ATTN:' />
    <div className='home-header'>
      <Header theme='dark' />
      <div className='hero--fullbleed'>
        <HeroVideo
          desktopPosterSrc={data.hero.image_desktop.url}
          mobilePosterSrc={data.hero.image_mobile.url}
          desktopVideoSrc={data.hero.loop_desktop.file.url}
          mobileVideoSrc={data.hero.loop_mobile.file.url}
        />
      </div>
    </div>
    <section className='creative-shop-intro'>
      <div className='creative-shop-intro__body'>
        We accelerate growth for brands, putting them at the center of culture
        so they become the center of attention.
      </div>
    </section>
    <ScrollingBanner
      background='grey'
      text='Capabilities'
      iconColor='red'
      length={10}
    />
    <section className='creative-shop-capabilities'>
      <ul className='capabilities__list'>
        <li className='capabilities__item'>Brand Strategy.</li>
        <li className='capabilities__item'>
          Fully integrated Campaign Development.
        </li>
        <li className='capabilities__item'>Comms Planning.</li>
        <li className='capabilities__item'>
          Social Strategy and Community Management.
        </li>
        <li className='capabilities__item'>Social Content Creation.</li>
        <li className='capabilities__item'>End-to-end Production.</li>
        <li className='capabilities__item'>
          ATTN: Creator CoLab<sup>™</sup>
        </li>
        <li className='capabilities__item'>
          ATTN: Assembly<sup>™</sup>
        </li>
      </ul>
    </section>
    <ScrollingBanner
      background='black'
      text='Our work'
      iconColor='red'
      length={10}
    />
    <VerticalList verticals={data.allDrupalProject.edges} />
    <ScrollingBanner
      background='grey'
      text='Creator CoLab'
      iconColor='red'
      length={10}
    />
    <section className='creator-colab'>
      <div className='creator-colab__logo'>ATTN: Creator CoLab<sup>™</sup></div>
      <div className='creator-colab__grid'>
        <div className='creator-colab__video'>
          <HeroVideo
            desktopPosterSrc={data.creatorCoLab.image_desktop.url}
            mobilePosterSrc={data.creatorCoLab.image_mobile.url}
            desktopVideoSrc={data.creatorCoLab.loop_desktop.file.url}
            mobileVideoSrc={data.creatorCoLab.loop_mobile.file.url}
          />
        </div>
        <div className='creator-colab__info'>
          <h2 className='creator-colab__heading'>
            Introducing <span>ATTN: Creator CoLab</span>, where creators and
            brands unite to unlock the power of influence.
          </h2>
          <p className='creator-colab__description'>
            Our Creator CoLab” connects brands to creators in a way that
            prioritizes meaningful engagement. Unlike standard influencer agencies
            who execute on one-off transactions, we build creator cohorts that
            offer resources, education, and networking opportunities, helping
            brands form authentic, mission-aligned partnerships. This approach
            fosters collaboration, strengthens the creator economy, and ensures
            deeper, sustainable relationships for both brands and creators.
          </p>
          <p className='creator-colab__description'>
            We use advanced AI to match creators to campaigns, including content,
            events, appearances, and more. Combining data and human insight, we
            deliver authentic storytelling and measurable results.
          </p>
          <p className='creator-colab__description'>
            Whether you're a creator seeking growth or a brand crafting powerful
            campaigns, ATTN: Creator CoLab blends creativity and analytics to
            forge meaningful connections.
          </p>
        </div>
      </div>
    </section>
    <ScrollingBanner
      background='pink'
      text='ATTN: Assembly'
      iconColor='red'
      length={10}
    />
    <section className='creative-shop-assembly'>
      <div className='assembly__images'>
        <ImageSlider images={images} />
      </div>
      <div className='assembly__headline'>Our proprietary research tool</div>
      <div className='assembly__logo'>
        <img src={attnAssemblyLogo} alt='ATTN Assembly' />
      </div>
      <div className='assembly__copy'>
        We are so audience obsessed that we built our own panel of 5,000+
        culturally connected doers and deciders
      </div>
      <div className='assembly__grid'>
        <div className='assembly__item'>
          <p className='assembly__item__heading'>
            UNCOVERING INSIGHTS &<br /> EMERGING TRENDS
          </p>
          <p className='assembly__item__description'>
            Our panel allows us to uncover powerful consumer insights to inform
            strategy and inspire break-through work that resonates with
            consumers
          </p>
        </div>
        <div className='assembly__item'>
          <p className='assembly__item__heading'>
            PRE-TESTING<br /> PLATFORM
          </p>
          <p className='assembly__item__description'>
            We can get an early read on conceptual directions and executions in
            advance, allowing us to optimize based on learnings before we go to
            market.
          </p>
        </div>
        <div className='assembly__item'>
          <p className='assembly__item__heading'>
            CUSTOM BRAND<br /> STUDIES
          </p>
          <p className='assembly__item__description'>
            We can explore brand perceptions and measure the effectiveness of
            campaigns through Quantitative and Qualitative brand studies.
          </p>
        </div>
      </div>
    </section>
    <Footer />
  </div>
)

CreativeShopPage.propTypes = {
  data: PropTypes.object
}

export default CreativeShopPage

export const query = graphql`
  query CreativeShopPage {
    hero: drupalMedia(pid: {eq: "124"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
      loop_mobile {
        file {
          url
        }
      }
      loop_desktop {
        file {
          url
        }
      }
    }
    creatorCoLab: drupalMedia(pid: {eq: "178"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
      loop_mobile {
        file {
          url
        }
      }
      loop_desktop {
        file {
          url
        }
      }
    }
    allDrupalProject(filter: {weight: {gt: 0}}, sort: {fields: [weight], order: ASC}) {
      edges {
        node {
          id
          label
          platform: eyebrow
          title
          description
          cta: link {
            title
            url {
              path
            }
          }
          image_mobile {
            url
          }
          image_desktop {
            url
          }
          video_mobile: loop_mobile {
            file {
              url
            }
          }
          video_desktop: loop_desktop {
            file {
              url
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/creativeshop.js